// サービス終了に伴いAPIを停止したため、更新系の操作は利用できない
import { rejectServiceClosed } from 'api/errors';

interface PostActivateRequest {
  id: string;
  activationCode: string;
}

export const useActivateUser = () => {
  const postActivate = (_data: PostActivateRequest): Promise<void> => rejectServiceClosed();

  return { postActivate };
};
